module.exports = __webpack_public_path__ + "media/images/img-angel-4cc2905fa1ebdd1fbfd6cf9824e1ac37.svg";